import React from 'react';

type PDPPageReviewSectionProps = {
  productId: string;
  isVisible: boolean;
  options: Record<string, string>;
};

export const PDPPageReviewSection = ({ productId, isVisible, options }: PDPPageReviewSectionProps) => {
  return (
    <div style={{ padding: '10px', border: '1px solid green' }}>
      Review PDP Page Component (from package) {productId} {isVisible}
      {options.color} {options.size}
    </div>
  );
};
